import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { PagePath } from '@monorepo/client-types';
import { DesignIcon, SystemIcon } from '@monorepo/nova-icons';
import { designTokens, Typography } from '@monorepo/nova-ui';
import {
  StyledCartCheckoutButton,
  StyledCartCloseButton,
  StyledCartEmptyStateContainer,
} from './cart.styled';

interface CartEmptyStateProps {
  onClose: () => void;
}

export const CartEmptyState = ({ onClose }: CartEmptyStateProps) => {
  const { t } = useTranslation('hubCommon');
  const navigate = useNavigate();

  const handleNewOrderClick = () => {
    navigate(PagePath.Purchase);
  };

  return (
    <StyledCartEmptyStateContainer>
      {/* Close button - absolute positioned top-right */}
      <StyledCartCloseButton size="small" onClick={onClose}>
        <SystemIcon iconName="Close" size={16} />
      </StyledCartCloseButton>

      {/* Cart icon */}
      <DesignIcon useMuiSvgIcon={false} iconName="EmptyState" />

      {/* Empty cart message */}
      <Typography
        variant="body2"
        fontWeight={designTokens.typography.fontWeights.semiBold}
        textAlign="center"
      >
        {t('cart.emptyState.title')}
      </Typography>

      {/* Secondary message */}
      <Typography
        variant="caption"
        fontWeight={designTokens.typography.fontWeights.regular}
        textAlign="center"
      >
        {t('cart.emptyState.messageLine1')}
        <br />
        {t('cart.emptyState.messageLine2')}
      </Typography>

      {/* New Order button */}
      <StyledCartCheckoutButton
        variant="accent"
        size="sm"
        endIcon={<SystemIcon iconName="CaretRight" />}
        onClick={handleNewOrderClick}
      >
        {t('newOrder')}
      </StyledCartCheckoutButton>
    </StyledCartEmptyStateContainer>
  );
};
